import AuthLayout from "../layouts/AuthLayout";
import PhoneNumber from "../pages/PhoneNumber";
import PhoneVerificationCode from "../pages/PhoneVerificationCode";
import ProtectedRoute from "@/shared/components/guards/ProtectedRoute";

const phoneVerificationRoutes = {
  path: "/verify-phone",
  element: (
    <ProtectedRoute allowUnverifiedAccess>
      <AuthLayout />
    </ProtectedRoute>
  ),
  children: [
    {
      element: <PhoneNumber />,
      index: true,
    },
    {
      path: "code",
      element: <PhoneVerificationCode />,
    },
  ],
};

export default phoneVerificationRoutes;
